import {
  Getters,
  Mutations,
  Actions,
  Module,
  createMapper
} from 'vuex-smart-module'
import _ from 'lodash'

class PublicationEditState {
  publication: any = {} // TODO set interface
  validation: { [k: number]: boolean } = {}
}

class PublicationEditGetters extends Getters<PublicationEditState> {
  get publication() {
    return this.state.publication
  }
  get validationStatus() {
    const status = Object.values(this.state.validation)
    return !status.includes(false) || !status.length
  }
}

class PublicationEditMutations extends Mutations<PublicationEditState> {
  setPublication(publication: any) {
    this.state.publication = publication
  }
  setValidation({ isValid, index }: { isValid: boolean; index: number }) {
    this.state.validation[index] = isValid
    this.state.validation = _.cloneDeep(this.state.validation)
  }
}

class PublicationEditActions extends Actions<
  PublicationEditState,
  PublicationEditGetters,
  PublicationEditMutations,
  PublicationEditActions
> {
  async fetchPublication() {
    const response = { data: {} }
    this.mutations.setPublication(response.data)
  }
}

export const publicationEdit = new Module({
  state: PublicationEditState,
  getters: PublicationEditGetters,
  mutations: PublicationEditMutations,
  actions: PublicationEditActions
})

export const publicationEditMapper = createMapper(publicationEdit)
